module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-latin122.98035ff.woff2";